// /frontend/src/plugins/i18n.ts

/**
 * Creates and configures the vue-i18n instance.
 *
 * @author Alexander Funke
 * @lastChange 2025-09-15
 */

import { createI18n, type MessageCompiler } from 'vue-i18n';
import localeMessages from '../locale';

/**
 * A custom message compiler that treats all messages as plain text.
 * This bypasses the ICU message format compiler, preventing errors with special characters.
 *
 * @param message The raw message string from the locale file.
 * @returns The message string, un-compiled.
 */
const plainTextMessageCompiler: MessageCompiler = (message: any) => {
  return () => message;
};

/**
 * The configured vue-i18n instance.
 */
const i18n = createI18n({
  legacy: false,
  locale: "en-US",
  fallbackLocale: "en-US",
  messages: localeMessages,
  messageCompiler: plainTextMessageCompiler,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});

export default i18n;
